// Persist only exact opaque recovery coordinates, never answers or notes.
// Current Auth/Personal/grant authority is required for every owner result read.
const operations = ['ENROLL', 'RESUME', 'COMPLETE', 'QUIZ_START', 'QUIZ_SUBMIT', 'NOTES_WRITE'];
export function learningCustody(uid, selection, grantId, changed) {
  const storageKey = `carrierflow:website-learning:v3:${JSON.stringify([uid, selection, grantId])}`;
  let pending = null, retry = null, alive = true;
  try { const value = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    if (value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 3
      && /^[A-Za-z0-9_-]{1,160}$/.test(value.idempotencyKey) && operations.includes(value.operation)
      && (value.lessonId === null || typeof value.lessonId === 'string' && value.lessonId.length <= 200)) pending = value;
  } catch { /* Storage availability is required before submitting a new change. */ }
  function clear(original) {
    try { if (sessionStorage.getItem(storageKey) === JSON.stringify(original)) sessionStorage.removeItem(storageKey); } catch { /* Keep the known in-memory disposition. */ }
    if (pending === original) { pending = null; retry = null; if (alive) changed(); }
  }
  return {
    get pending() { return pending; }, get canRetry() { return !!retry; }, activate() { alive = true; },
    async execute(operation, lessonId, submit) {
      if (!alive) throw new Error('This learning context closed.');
      if (pending) throw new Error('Resolve the original learning request before starting another change.');
      const original = Object.freeze({ operation, lessonId, idempotencyKey: crypto.randomUUID() });
      try { sessionStorage.setItem(storageKey, JSON.stringify(original)); }
      catch { throw new Error('Enable tab storage so the learning recovery handle can survive reload before making this change.'); }
      pending = original; retry = () => submit(original.idempotencyKey).then(result => { clear(original); return result; }); changed(); return retry();
    },
    async retry() { if (!alive || !retry) throw new Error('The original input is no longer in memory. Read its result or cancel the original request.'); return retry(); },
    async recover(read) {
      const original = pending; if (!alive || !original) throw new Error('No original request is pending.');
      const result = await read(original); if (result.state !== 'UNRESOLVED') clear(original); return { ...result, handle: original };
    },
    dispose() { alive = false; retry = null; },
  };
}
